/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-item.logout[_ngcontent-%COMP%]{cursor:pointer}nac-alert-center[_ngcontent-%COMP%]{position:fixed;z-index:1000;width:100%}\n/*# sourceMappingURL=navbar.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/theme/navbar/navbar.component.css.shim.ngstyle.js.pre-build-optimizer.js